export default __webpack_public_path__ + "static/Recoleta-Bold-c14f28ae262d9580eb55bcb99079f24d.woff2";